var NAMESPACE = 'td';

var Icon = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _vm.svg ? _c('svg', { staticClass: "td-icon-svg", class: 'td-icon-svg-' + _vm.type, attrs: { "aria-hidden": "true" } }, [_c('use', { attrs: { "xmlns:xlink": "http://www.w3.org/1999/xlink", "xlink:href": '#td-icon-svg-' + _vm.type } })]) : _c('i', { class: 'td-icon-' + _vm.type });
  }, staticRenderFns: [],
  name: NAMESPACE + '-icon',
  props: {
    type: {
      type: String,
      require: true
    },
    svg: {
      type: Boolean,
      default: false
    }
  }
};

Icon.install = function (Vue) {
  Vue.component(Icon.name, Icon);
};

export default Icon;
